"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quickOrderedFilter = void 0;
const utils_1 = require("./utils");
const prepareValue = (value) => {
    return (0, utils_1.exists)(value) ? value.toString().toLowerCase() : null;
};
/**
 * The base implementation
 *
 * @param {Array} hay The array to inspect.
 * @param {Array} queryParts Parts of the query to look for in hay.
 * @returns {boolean} Returns if hay contains all query parts in their order.
 */
function quickOrderedFilter(hay, queryParts) {
    if (hay.length === 0)
        return false;
    let lastIndex = 0;
    return (0, utils_1.every)(queryParts, (part) => {
        const index = (0, utils_1.baseFindIndex)(hay, (item) => {
            const value = prepareValue(item);
            return (0, utils_1.exists)(value) && value.indexOf(part) === 0;
        }, lastIndex);
        if (index < 0)
            return false;
        lastIndex = index + 1;
        return true;
    });
}
exports.quickOrderedFilter = quickOrderedFilter;
